import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import useConfig from '../hooks/useConfig';

const VehiclesWebComponent = ({ brands, models, bodyTypes }) => {
  const { searchResultType } = useConfig();
  const [appUrl, setAppUrl] = useState('');

  // this fix ssr warning
  useEffect(() => {
    setAppUrl(window.location.origin);
  }, []);

  const apiUrl = process.env.API_URL;

  return (
    <intelimotor-vehicles
      app-url={appUrl}
      api-url={apiUrl}
      brands={brands.join('|')}
      models={models.join('|')}
      body-types={bodyTypes.join('|')}
      variant={searchResultType.toLowerCase()}
    />
  );
};

VehiclesWebComponent.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.string),
  models: PropTypes.arrayOf(PropTypes.string),
  bodyTypes: PropTypes.arrayOf(PropTypes.string),
};

VehiclesWebComponent.defaultProps = {
  brands: [],
  models: [],
  bodyTypes: [],
};

export default VehiclesWebComponent;
